<template>
  <div class="scrolling-wrapper">
    <placeholder-image 
      v-for="(image, index) in images" 
      @click="initialSlide = index, show=true" 
      :key="index" 
      :url="image" 
      class="clickable" 
      :height="imagesHeight" 
      :width="imagesWidth"
    />
    <preview-images 
      :show="show" 
      @close="show = false" 
      :images="images" 
      :initialSlide="initialSlide"
    />
  </div>
</template>

<script>
export default {
  props: {
    images: Array,
    imagesHeight: {
      type: Number,
      default: 100,
    },
    imagesWidth: {
      type: Number,
      default: 100,
    },
  },
  components: {
    PreviewImages: () => import('@/components/app-components/PreviewImages.vue'),
    PlaceholderImage: () => import('@/components/app-components/PlaceholderImage.vue'),
  },
  data () {
    return {
      show: false,
      initialSlide: null,
    }
  },
}
</script>

<style lang="scss">
.scrolling-wrapper {
  overflow-x: auto;
  display: flex;
  flex-direction: row;
  max-width: 100%;
  gap: 15px;
  .v-image {
    border-radius: 10px;
  }
}
</style>
